import { render, staticRenderFns } from "./OtpResetPassword.vue?vue&type=template&id=1e08d85c&scoped=true&"
import script from "./OtpResetPassword.vue?vue&type=script&lang=js&"
export * from "./OtpResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./OtpResetPassword.vue?vue&type=style&index=0&id=1e08d85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e08d85c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e08d85c')) {
      api.createRecord('1e08d85c', component.options)
    } else {
      api.reload('1e08d85c', component.options)
    }
    module.hot.accept("./OtpResetPassword.vue?vue&type=template&id=1e08d85c&scoped=true&", function () {
      api.rerender('1e08d85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/OtpResetPassword.vue"
export default component.exports